@if (series_ready) {
  <generic-chart
    class="chart"
    [config]="chart_config"
    style="height:100%;width:100%;"
    >
  </generic-chart>
}
